import { render, staticRenderFns } from "./AdminBasicSales.vue?vue&type=template&id=4750098c"
import script from "./AdminBasicSales.vue?vue&type=script&lang=js"
export * from "./AdminBasicSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports